export enum USER_ROLE {
  OWNER = 'owner',
  MANAGER = 'manager',
  VIEWER = 'viewer',
}
